import { Controller } from "@hotwired/stimulus"

// Closes the status checkbox menu when the user clicks anywhere else.
export default class extends Controller {
  connect() {
    this._close = (event) => {
      if (!this.element.contains(event.target)) this.element.open = false
    }
    document.addEventListener("click", this._close)
  }

  disconnect() {
    document.removeEventListener("click", this._close)
  }
}
